// @ts-nocheck
import {
  buildColumnMap,
  buildCompositeHeaders,
  buildNormalizedAliases,
  buildStandardRecord,
  cleanText,
  shouldSkipRecord,
  normalizeHeader,
  guessPharmaceuticalCompanyName,
} from './settlementTemplateHelpers.js';

const JEIL_FIELD_ALIASES = {
  receiverName: ['회수처명'],
  accountName: ['거래처명'],
  drugName: ['제품명'],
  feeRate: ['정산율 np회수처'],
  quantity: ['수량'],
  unitPrice: ['기준가'],
  prescriptionAmount: ['처방금액'],
  settlementAmount: ['산출금액 회수처정산'],
  note: ['비고(해당월)'],
  noteReason: ['정산보류 사유'],
};

const REQUIRED_TOKENS = [
  '회수code',
  '거래처명',
  '처방code',
  '제품명',
  '산출금액',
];
const JEIL_HEADER_START_INDEX = 1;
const JEIL_HEADER_ROW_COUNT = 2;
const JEIL_DATA_START_INDEX = 3;

function isJeilProfile(profile) {
  const headerAreaTokens = profile.headerAreaRows.flatMap((row) => row.cells);
  return (
    normalizeHeader(profile.sheetName) === normalizeHeader('제일품목') &&
    REQUIRED_TOKENS.every((token) =>
      headerAreaTokens.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(token),
      ),
    )
  );
}

const jeilPharmTemplate = {
  id: 'jeil-pharm',
  name: '제일약품 템플릿',
  match(context) {
    return context.headerProfiles.some(isJeilProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isJeilProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const sheetRows = context.sheetRowsMap[sheetName] || [];
    const compositeHeaders = buildCompositeHeaders(
      sheetRows,
      JEIL_HEADER_START_INDEX,
      JEIL_HEADER_ROW_COUNT,
    );
    const columnMap = buildColumnMap(
      compositeHeaders,
      buildNormalizedAliases(JEIL_FIELD_ALIASES),
    );
    const detectedPharmaceuticalCompany = '제일약품';
    const extractedRows = [];
    const dataStartIndex = JEIL_DATA_START_INDEX;

    sheetRows.slice(dataStartIndex).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const receiverName = cleanText(row[columnMap.receiverName]);
      if (!receiverName) {
        return;
      }

      const noteParts = [row[columnMap.note], row[columnMap.noteReason]]
        .map((value) => cleanText(value))
        .filter(Boolean);

      const record = buildStandardRecord({
        fileName: context.file.name,
        sheetName,
        rowIndex: dataStartIndex + rowOffset,
        templateId: this.id,
        detectedPharmaceuticalCompany,
        customerName: row[columnMap.accountName],
        drugCode: '',
        drugName: row[columnMap.drugName],
        feeRateValue: row[columnMap.feeRate],
        quantityValue: row[columnMap.quantity],
        unitPriceValue: row[columnMap.unitPrice],
        prescriptionAmountValue: row[columnMap.prescriptionAmount],
        settlementAmountValue: row[columnMap.settlementAmount],
        note: noteParts.join(' / '),
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default jeilPharmTemplate;
